// ============================================================================
// Idioma ACTUAL a nivel de módulo (oct-2026), para el código que corre fuera
// de un hook: helpers de formato, funciones auxiliares, textoDe().
//
// Lo fija el RegionalProvider. Cuando el idioma cambia, el provider vuelve a
// montar el árbol, así que cualquier helper que se llame DURANTE el render ve
// el idioma nuevo. Nunca leerlo en el nivel superior de un módulo (eso corre
// una sola vez, al importar).
// ============================================================================
import { IDIOMA_DEFECTO, esCodigoIdioma, type CodigoIdioma } from './idiomas.ts';

const CLAVE = 'salonika_idioma';

function leerGuardado(): CodigoIdioma {
  try {
    const v = localStorage.getItem(CLAVE);
    return esCodigoIdioma(v) ? v : IDIOMA_DEFECTO;
  } catch {
    return IDIOMA_DEFECTO;
  }
}

let actual: CodigoIdioma = leerGuardado();

export function getIdiomaActual(): CodigoIdioma {
  return actual;
}

/** Fija el idioma y lo recuerda en este navegador (para el login). Español no se guarda. */
export function setIdiomaActual(i: CodigoIdioma): void {
  actual = esCodigoIdioma(i) ? i : IDIOMA_DEFECTO;
  try {
    if (actual === IDIOMA_DEFECTO) localStorage.removeItem(CLAVE);
    else localStorage.setItem(CLAVE, actual);
  } catch { /* storage bloqueado: queda en memoria */ }
}

/**
 * Locale para FECHAS con nombres de mes o día ("17 de octubre", "sábado").
 * En español es 'es-CO' (exactamente lo de siempre). Los números y la plata
 * NO usan esto: siguen el formato de la moneda (es-CO con COP).
 */
export function localeFechas(): string {
  return actual === 'en' ? 'en-US' : 'es-CO';
}
